<template>
  <!-- 常务理事 -->
  <div id="Mandirect">
       <div class="crumbs">
        <i class="iconfont icon-zhuye"></i>
        <span><router-link :to="{ name: 'home' }">首页</router-link></span>
         <i class="iconfont icon-youjiantou"></i>
        <span ><router-link :to="{name:'aa'}">协会概况</router-link></span>
        <i class="iconfont icon-youjiantou"></i>
        <span
          ><router-link :to="{ name: 'Assocwindow' }"
            >常务理事</router-link
          ></span
        >
    </div>
    <p v-html="MemberList[0].Content"></p>
    <img v-if="MemberList[0].TitlePhoto" :src="MemberList[0].TitlePhoto" alt="">
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name:'Mandirect',
  data(){
    return{
      MemberList:[],
      Lmurl:'http://cmcpa.boyuancb.com'
    }
  },
  components:{

  },
  methods:{
    getData(){
      axios.post('/SiteContentAPI/GetPageList',{
        ChannelID:2835,
        JournalID:202007100001,
        CurrentPage:1,
        PageSize:8
      }).then((res) => {
        this.MemberList = res.data._itemList//党建学习
        // this.MemberList.forEach((item) => {
        //   item.TitlePhoto = this.Lmurl + item.TitlePhoto
        // })
      })
    }
  },
  created(){
    this.getData();
  }
}
</script>

<style lang="less" scoped>
  #Mandirect{
    width:100%;
    margin:0 auto;
          .crumbs {
    width: 1200px;
    height: 20px;
    position: relative;
    text-align: left;
    margin-top: 24px;
    margin-bottom: 20px;
    // margin-left: 2%;
    line-height: 20px;
    span:nth-child(2) a {
      color: #000000;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
    }
    i {
      color: #767c82;
      font-size: 18px;
      margin-left: 10px;
      font-weight: bold;
    }
    i:nth-child(1) {
      color: #000;
      margin-right: 5px;
    }
     span:nth-child(4) a {
      color: #000;
      font-size: 16px;
      margin-left: 10px;
      font-weight: bold;
      cursor: pointer;
    }
    span:nth-child(6) a {
      color: #c01b22;
      font-size: 16px;
      margin-left: 10px;
      font-weight: bold;
      cursor: pointer;
    }
  }
    /deep/p{
			color:#000;
			font-size:18px!important;
			text-indent:2em;
			text-align: justify;
			letter-spacing: 2px;
      line-height: 32px!important;
      margin-right: 10px;
		}
		.infoTit{
			margin-top:20px;
		}
		.info{
			text-indent:0em;
			word-spacing: 9px;
		}
		.infobot{
			margin-top:20px;
		}
		img{
			width:425px;
			height:428px;
			margin-top:33px;
			margin-left:229px;
		}
  }
</style>



// WEBPACK FOOTER //
// src/components/Assocwindow/Mandirect/index.vue